import { render, staticRenderFns } from "./baseMore.vue?vue&type=template&id=581e1bd0&scoped=true&"
import script from "./baseMore.vue?vue&type=script&lang=js&"
export * from "./baseMore.vue?vue&type=script&lang=js&"
import style0 from "./baseMore.vue?vue&type=style&index=0&id=581e1bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e1bd0",
  null
  
)

export default component.exports